import { Navigate, Outlet } from "react-router-dom";

const AuthLayout = () => {
  const token = localStorage.getItem("agent_access_token");

  if (token) return <Navigate to={"/"} replace />;

  return <Outlet />;
};

export default AuthLayout;
